import {useQuery} from 'react-query';
import getStoreSupplierProfile from '.';

const useGetStoreSupplierProfile = ({
  handleAfterSuccessSupplierProfile,
}: {
  handleAfterSuccessSupplierProfile?: (data: IStoreSupplierProfile) => void;
}) => {
  const {data, isLoading} = useQuery(
    ['get-store-supplier-profile'],
    getStoreSupplierProfile,
    {
      onSuccess: data => {
        handleAfterSuccessSupplierProfile &&
          handleAfterSuccessSupplierProfile(data);
      },
    },
  );

  return {data, isLoading};
};

export default useGetStoreSupplierProfile;
